<template>
  <div class="mobile-station-detail">
    <div class="subheader">
      <RouterLink tag="button" :to="{ name: 'overview' }" class="back f9">
        <UIIcon name="chevron-left" />
        {{ $t('Back to Overview') }}
      </RouterLink>
      <div class="title f5">{{ station.title }}</div>
    </div>
    <div class="mobilestationwithcalendar">
      <VerticalCalendar :isNetworkAvailable="isNetworkAvailable" :bookings="bookings" :times="times" :station="station" :currentTime="currentTime" :calendarDate="calendarDate" :location="location" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import VerticalCalendar from './VerticalCalendar';
import StationCard from '../station-list/card/StationCard';
import OverviewHelper from '@/location/overview/OverviewHelper';
import UIIcon from '@/core/shared/components/ui/UIIcon';

@Component({
  props: {
    stationId: {
      type: String,
      required: true,
    },
    locationId: {
      type: String,
      required: true,
    },
  },
  components: {
    VerticalCalendar,
    StationCard,
    UIIcon,
  },
})
export default class MobileStationDetailRoute extends Vue {
  created () {
    this.$store.commit('setShowHeader', false);
  }

  get currentTime () { return this.$store.getters.currentTime; }
  get calendarDate () { return this.$store.getters.calendarDate; }
  get isNetworkAvailable () { return this.$store.getters.isNetworkAvailable; }

  get station () {
    return this.$store.getters['entities/Station'](this.stationId);
  }

  get times () {
    return OverviewHelper.getTimesForCalendarHeader(this.currentTime);
  }

  get location () {
    return this.$store.getters['entities/Location'](this.locationId);
  }

  // yeah this method isn't great, but it basically gets all bookings then just filters
  // what you need for the current station.
  //
  // If you want to clean it up, then we should make a getter than accepts both locationId and stationId.
  // You wouldn't use that in the Calendar.vue component because you want that to be a 'dumb component'.
  //
  // It's fine... this is fine...
  get bookings () {
    return this.$store.getters.locationBookingsOnDate({
      locationId: this.locationId,
      date: this.calendarDate,
    }).filter(booking => {
      return booking.bookingStationTimes.find(bookingStationTime => bookingStationTime.station.id === this.stationId);
    });
  }

  destroyed () {
    this.$store.commit('setShowHeader', true);
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.mobile-station-detail {
  & .subheader {
    padding: var(--spacingXS) var(--spacingSm);
    display: flex;
    justify-content: space-between;
    align-items: center;
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    z-index: 2;
    background-color: var(--colorCasper);
    box-shadow: var(--shadowSm);

    & .back {
      position: relative;
      display: flex;
      align-items: center;
      left: -1.5rem;
      color: var(--colorManatee);
      appearance: none;
      background-color: transparent;
      border: none;
    }

    & svg {
      width: 2.5rem;
      height: 2.5rem;
      fill: var(--colorManatee);
    }
  }

  & .mobilestationwithcalendar {
    z-index: var(--zContent);
    display: flex;
    flex-direction: column;

    & .station-card {
      flex: 0 0 auto;
      z-index: 2;
    }
  }
}
</style>
